import React from "react";
import PropTypes from "prop-types";
import getConfig from "next/config";
import Modal from "@components/Modal";

const {
  publicRuntimeConfig: {
    settings: { cdn },
  },
} = getConfig();

const ProductEnergyLabelModal = ({ productName, labelPath }) => {
  if (productName && labelPath) {
    return (
      <Modal id="productEnergyLabel" header={productName}>
        <img
          // TODO: Use resizeImage for src and
          // add 320x0 width/height config in mediaserver
          // We have only square resizes right now
          src={`${cdn}${labelPath}`}
          alt={`Eticheta energetica ${productName}`}
          className="mx-auto"
          style={{ maxWidth: "320px" }}
        />

        <style global jsx>{`
          .Modal-productEnergyLabel {
            max-width: 575px;
          }
        `}</style>
      </Modal>
    );
  }

  return null;
};

ProductEnergyLabelModal.propTypes = {
  productName: PropTypes.string.isRequired,
  labelPath: PropTypes.string.isRequired,
};

export default ProductEnergyLabelModal;
